// extracted by mini-css-extract-plugin
module.exports =  {"price-discount":"_0bc5e8de02--price-discount--Yqg25","old-price":"_0bc5e8de02--old-price--YpBlb"};